import axios from 'axios';
import useAuthStore from '../stores/authStore';
import authService from '../services/authService';

const API_BASE_URL = 'https://n8n.wajok.com/webhook/api/';

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    // withCredentials를 전역에서 제거하고 인터셉터에서 조건부로 적용합니다.
    timeout: 30000, // n8n 특성상 처리 시간이 길 수 있으므로 30초로 늘립니다.
    headers: {
        'Content-Type': 'application/json',
    },
});

// 요청 인터셉터
axiosInstance.interceptors.request.use(
    (config) => {
        const { accessToken } = useAuthStore.getState();

        // n8n.wajok.com 도메인인 경우에만 인증 정보 주입
        const isInternalRequest = config.url && (
            config.url.includes('n8n.wajok.com') ||
            (config.baseURL && config.baseURL.includes('n8n.wajok.com') && !config.url.startsWith('http'))
        );

        if (isInternalRequest && accessToken) {
            // 토큰이 있는 경우에만 Authorization 헤더 추가
            config.headers['Authorization'] = `Bearer ${accessToken}`;
            // 주의: withCredentials는 특정 엔드포인트(login/refresh)에서만 필요하므로 
            // 전역 인터셉터에서는 n8n CORS 설정에 따라 신중히 결정해야 합니다.
            // 일단 제거하여 CORS 에러를 회피해봅니다.
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 응답 인터셉터
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        const { accessToken } = useAuthStore.getState();

        // 에러가 401이고 아직 재시도하지 않은 경우 확인
        // 메모리에 액세스 토큰이 있는 경우(즉, 로그인 상태였다가 만료된 경우)에만 갱신 시도
        if (error.response && error.response.status === 401 && !originalRequest._retry && accessToken) {
            originalRequest._retry = true;

            try {
                // 조용한 갱신(Silent Refresh) 시도
                const result = await authService.silentRefresh();

                if (result.success) {
                    originalRequest.headers['Authorization'] = `Bearer ${result.access_token}`;
                    return axiosInstance(originalRequest);
                } else {
                    // 갱신 실패 (리프레시 토큰 만료 등)
                    if (!window._isSessionExpiredAlerted) {
                        window._isSessionExpiredAlerted = true;
                        alert("세션이 만료되었습니다. 다시 로그인해주세요.");
                        setTimeout(() => { window._isSessionExpiredAlerted = false; }, 5000);

                        // 로그인 모달을 띄우기 위한 이벤트 발생 (App.js에서 수신 가능)
                        window.dispatchEvent(new CustomEvent('wablog_session_expired'));
                    }
                    useAuthStore.getState().logout();
                    return Promise.reject(error);
                }
            } catch (refreshError) {
                useAuthStore.getState().logout();
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
